import React, { ComponentProps } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Button, Confirm } from 'semantic-ui-react';

type ConfirmWithIntlProps = ComponentProps<typeof Confirm> & {
  /** Intl id used to display header */
  headerId?: string;
  /** Intl id used to display confirm button */
  confirmId?: string;
  /** Intl id used to display cancel button */
  cancelId?: string;
  /** Intl id used to display content */
  contentId?: string;
  /** Warning user with red color that the confirm button is dangerous */
  dangerous?: boolean;
};

export default function ConfirmWithIntl({
  contentId,
  headerId,
  confirmId,
  cancelId,
  dangerous = false,
  ...props
}: ConfirmWithIntlProps) {
  const intl = useIntl();

  const propsWithIntl = {
    confirmButton: dangerous ? (
      <Button negative>
        <FormattedMessage id={confirmId ?? 'general.confirm'} />
      </Button>
    ) : (
      intl.formatMessage({ id: confirmId ?? 'general.confirm' })
    ),
    cancelButton: intl.formatMessage({ id: cancelId ?? 'general.cancel' }),
    content: contentId ? intl.formatMessage({ id: contentId }) : undefined,
    header: headerId ? intl.formatMessage({ id: headerId }) : undefined,
    ...props,
  };

  return <Confirm {...propsWithIntl} />;
}
